/* global $ */

import './components/payments';

$(document).foundation();
